<div class="d-flex justify-content-between">
    <label>{{ "widget_product_variants_label" | translate }}</label>
    <a [class.disabled]="hasPropertiesInEdit" (click)="addVariant()">{{ "widget_product_add_variant" | translate }}</a>
</div>

@if (properties.controls.length) {
    <div class="d-flex flex-column" cdkDropList [cdkDropListData]="properties" (cdkDropListDropped)="drop($event)">
        @for (property of properties.controls; track property; let i = $index) {
            <div cdkDrag cdkDropListGroup [cdkDragData]="property.value">
                <div
                    class="variant-row well well-sm"
                    [class.variant-row-error]="hasPropertiesInEditError && property.value.isEdit"
                >
                    @if (!property.value.isEdit) {
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex">
                                <img cdkDragHandle class="handle mr-10" src="./assets/img/dnd-icon.svg" alt="icon" />
                                <div class="text-muted">
                                    <span class="bold">{{ property.value.name }}:</span> {{ property.value.parameters }}
                                </div>
                            </div>
                            <div class="d-flex">
                                <button class="btn-link edit-btn" (click)="editProperty(i)">
                                    <span class="sp-icon icon-pencil"></span>
                                </button>
                                <button class="btn-link remove-btn" (click)="removeProperty(i)">
                                    <span class="sp-icon icon-bin"></span>
                                </button>
                            </div>
                        </div>
                    } @else {
                        <div (keyup.enter)="save(i)">
                            <div class="form-group mb-10 w-100">
                                <input
                                    class="form-control"
                                    placeholder="{{ 'widget_product_variant_name' | translate }}"
                                    [formControl]="property.controls.name"
                                    (change)="editName($event.target['value'], i)"
                                />
                            </div>
                            <div class="form-group mb-10 w-100">
                                <input
                                    class="form-control"
                                    placeholder="{{ 'widget_product_variant_property' | translate }}"
                                    [formControl]="property.controls.parameters"
                                    (change)="editParams($event.target['value'], i)"
                                />
                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                                <a class="btn btn-primary" (click)="save(i)" (keyup.enter)="save(i)">
                                    {{ "add" | translate }}
                                </a>
                                <a class="dotted" (click)="cancelEdit(i)">
                                    {{ "cancel" | translate }}
                                </a>
                            </div>
                            @if (hasPropertiesInEditError && property.value.isEdit) {
                                <p class="variant-error-text">
                                    {{ "widget_product_properties_error" | translate }}
                                </p>
                            }
                        </div>
                    }
                </div>
            </div>
        }
    </div>
    @if (variants.length) {
        <div class="variant-table-responsive">
            <table class="table variant-table">
                <tbody>
                    <tr>
                        <th>{{ "widget_product_variants" | translate }}</th>
                        <th>{{ "widget_product_vendor_code" | translate }}</th>
                        <th>{{ "widget_product_variant_preview" | translate }}</th>
                        <th>{{ "widget_product_price" | translate }}</th>
                        <th>{{ "widget_product_old_price" | translate }}</th>
                        <th>{{ "widget_product_quantity" | translate }}</th>
                    </tr>
                    @for (variant of variants.controls; track variant; let i = $index) {
                        <tr>
                            <td [ngClass]="{ 'hidden-variant': !variant.value.isShow }">
                                <label class="sp-checkbox hide-variant-wrapper">
                                    @if (!variant.value.isShow) {
                                        <span
                                            class="sp-icon icon-eye"
                                            [tooltip]="'widget_product_variant_show' | translate"
                                        ></span>
                                    }
                                    @if (variant.value.isShow) {
                                        <span
                                            class="sp-icon icon-minus2 text-muted"
                                            [tooltip]="'widget_product_variant_hide' | translate"
                                        ></span>
                                    }
                                    <input
                                        class="checkbox-input hide-variant-toggle"
                                        type="checkbox"
                                        [checked]="variant.value.isShow"
                                        (change)="changeCheckBoxValue(i)"
                                    />
                                </label>
                                <span class="td-value">{{ variant.value.name }}</span>
                            </td>
                            <td [ngClass]="{ 'hidden-variant': !variant.value.isShow }">
                                <div
                                    class="variant-table-cell"
                                    (click)="setEditingField(variant.controls.vendorCode.controls.isEditing, $event)"
                                    [hidden]="variant.value.vendorCode.isEditing"
                                >
                                    <span class="td-value">{{ variant.value.vendorCode.value }}</span>
                                    <span class="sp-icon icon-ap-edit color-light small"> </span>
                                </div>
                                <div [hidden]="!variant.value.vendorCode.isEditing" class="variant-cell-editing">
                                    <input
                                        #vendorCode
                                        (blur)="setEditingField(variant.controls.vendorCode.controls.isEditing)"
                                        (keyup.enter)="vendorCode.blur()"
                                        type="text"
                                        [formControl]="variant.controls.vendorCode.controls.value"
                                    />
                                </div>
                            </td>
                            <td [ngClass]="{ 'hidden-variant': !variant.value.isShow }">
                                @if (!cardImages.length) {
                                    <div class="empty-image-container">
                                        <sp-file-manager [multiSelect]="true" (setFileEvent)="addImage($event)">
                                            <sp-link-upload-button
                                                class="custom-link"
                                                [label]="'+'"
                                            ></sp-link-upload-button>
                                        </sp-file-manager>
                                    </div>
                                }
                                @if (cardImages.length) {
                                    <div
                                        class="preview-image-container td-value"
                                        (click)="handleImageEdit(i)"
                                        [class.active]="variant.value.isImageEdit"
                                    >
                                        <img [src]="formatImageURL(selectedPreviewImage(i).value)" [alt]="i" />
                                    </div>
                                    @if (variant.value.isImageEdit) {
                                        <div
                                            class="images-wrapper"
                                            spClickOutside
                                            (clickOutside)="handleImageEdit(i)"
                                            [rootClass]="'modal-body'"
                                            [clickClassClosePrevent]="'images-wrapper'"
                                        >
                                            @for (image of cardImages.value; track image; let index = $index) {
                                                <div class="image-container">
                                                    <div
                                                        class="image-wrapper"
                                                        (click)="setVariantImages(i, image)"
                                                        [class.selected]="isSelectedImage(i, image)"
                                                    >
                                                        <img [src]="formatImageURL(image)" [alt]="index" />
                                                    </div>
                                                </div>
                                            }
                                            <sp-file-manager [multiSelect]="true" (setFileEvent)="addImage($event)">
                                                <sp-link-upload-button
                                                    class="custom-link"
                                                    [label]="'+'"
                                                ></sp-link-upload-button>
                                            </sp-file-manager>
                                        </div>
                                    }
                                }
                            </td>
                            <td [ngClass]="{ 'hidden-variant': !variant.value.isShow }">
                                <div
                                    class="variant-table-cell"
                                    (click)="setEditingField(variant.controls.price.controls.isEditing, $event)"
                                    [hidden]="variant.value.price.isEditing"
                                >
                                    <span class="td-value">{{ variant.value.price.value }}</span>
                                </div>
                                <div [hidden]="!variant.value.price.isEditing" class="variant-cell-editing">
                                    <input
                                        #price
                                        type="number"
                                        (blur)="
                                            normalizeNonNegativeNumber(variant.controls.price.controls.value);
                                            setEditingField(variant.controls.price.controls.isEditing)
                                        "
                                        (keyup.enter)="price.blur()"
                                        (input)="normalizeNonNegativeNumber(variant.controls.price.controls.value)"
                                        [formControl]="variant.controls.price.controls.value"
                                    />
                                </div>
                            </td>
                            <td [ngClass]="{ 'hidden-variant': !variant.value.isShow }">
                                <div
                                    class="variant-table-cell"
                                    (click)="setEditingField(variant.controls.oldPrice.controls.isEditing, $event)"
                                    [hidden]="variant.value.oldPrice.isEditing"
                                >
                                    <span class="td-value">{{ variant.value.oldPrice.value }}</span>
                                    <span class="sp-icon icon-ap-edit color-light small"> </span>
                                </div>
                                <div [hidden]="!variant.value.oldPrice.isEditing" class="variant-cell-editing">
                                    <input
                                        #oldPrice
                                        type="number"
                                        (blur)="
                                            normalizeNonNegativeNumber(variant.controls.oldPrice.controls.value);
                                            setEditingField(variant.controls.oldPrice.controls.isEditing)
                                        "
                                        (keyup.enter)="oldPrice.blur()"
                                        (input)="normalizeNonNegativeNumber(variant.controls.oldPrice.controls.value)"
                                        [min]="0"
                                        [formControl]="variant.controls.oldPrice.controls.value"
                                    />
                                </div>
                            </td>
                            <td [ngClass]="{ 'hidden-variant': !variant.value.isShow }">
                                <div
                                    class="variant-table-cell"
                                    (click)="setEditingField(variant.controls.quantity.controls.isEditing, $event)"
                                    [hidden]="variant.value.quantity.isEditing"
                                >
                                    <span class="td-value">{{
                                        variant.value.quantity.value === 0 || variant.value.quantity.value
                                            ? variant.value.quantity.value
                                            : "&#8734;"
                                    }}</span>
                                    <span class="sp-icon icon-ap-edit color-light small"> </span>
                                </div>
                                <div [hidden]="!variant.value.quantity.isEditing" class="variant-cell-editing">
                                    <input
                                        #quantity
                                        type="number"
                                        placeholder="&#8734;"
                                        (blur)="setEditingField(variant.controls.quantity.controls.isEditing)"
                                        (keyup.enter)="quantity.blur()"
                                        [formControl]="variant.controls.quantity.controls.value"
                                    />
                                </div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
}
